
import { GameObjects } from "phaser";

import { buyTickets  } from '../utils';

export class Slider extends GameObjects.Container {

    constructor(scene, x, y, width = 686, height = 104, isDisabled = false) {
        super(scene, x, y);

     // Add this container to the scene
     scene.add.existing(this);


        this.setSize(width, height);

       
        // Store the different states of the button
        // this.texturePack = texturePack;
        // this.idleTexture = idleTexture;
        // this.hoverTexture = hoverTexture;
        // this.clickedTexture = clickedTexture;
        // this.disabledTexture = disabledTexture;
        this.isDisabled = isDisabled || false;

        this.amount = parseFloat(0).toFixed(2);

        //console.log("this.amount", this.amount);
        this.currency = "$"    
      
         //this.buttonSprite = scene.add.sprite(0, 0, 'pack', ).setInteractive();
         this.SliderBackground   = scene.add.nineslice(0, 0, 'pack', 'Slider-Base.png', width, height, 32, 32);

         this.add(this.SliderBackground);

         
         const bounds = this.getBounds();
         
         const valueTextStyle = { fontSize: 48, fontFamily: 'Oswald', color: '#fff', fontWeight:500 };

         //this.valueText = scene.add.text(bounds.width + bounds.x - 32, bounds.y+50, `$1,135.60`,  valueTextStyle).setOrigin(1,0.5)
         this.valueText = scene.add.text(bounds.width/2-32, 0, `${this.currency}${this.amount}`,  valueTextStyle).setOrigin(1,0.5)

         this.add(this.valueText);


        this.graphics = scene.add.graphics();

        this.graphics.fillStyle(0x00A39A, 1);

        this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2, 30,height -2, 10);
        

        this.add(this.graphics);

       
        
         //this.graphics2.setVisible(false);
        


        // const worldX = pointer.worldX;
        // const worldY = pointer.worldY;
        //  // Convert the world coordinates to container-relative coordinates
        //  const localPoint = scene.getLocalTransformMatrix().applyInverse(worldX, worldY);
        //  console.log("Local Coordinates inside container:", localPoint.x, localPoint.y);

        //this.SliderButton   = scene.add.sprite(-300, 0, 'pack', 'Button - Primary - Default.png').setOrigin(0,0.5);

        this.slideButtonContainer = scene.add.container(-318/2-32,0);
        this.slideButtonContainer.setSize(318,100).setInteractive();
        

        this.add(this.slideButtonContainer);

        //console.log(this.slideButtonContainer)
         
         this.SliderButton  = scene.add.nineslice(1, 0, 'pack', 'Button - Primary - Default.png', 318, height, 32, 32);

         this.SliderButtonXOrigin = this.SliderButton.x

         //this.add(this.SliderButton);

        this.slideButtonContainer.add(this.SliderButton);


        // { draggable: true }

          // Enable dragging for the sprite
        scene.input.setDraggable(this.slideButtonContainer);

        // this.graphicsC = scene.add.graphics();
        // this.graphicsC.clear();

        // this.graphicsC.lineStyle(1, 0xff0000);
        // this.graphicsC.strokeRectShape(this.slideButtonContainer.getBounds());


        const buttonTextStyle = { fontSize: 32, fontFamily: 'Oswald', color: '#EEE', fontWeight:500 };

        this.buttonText = scene.add.text(-100, 0, `SLIDE TO BUY`,  buttonTextStyle).setOrigin(0,0.5)

        

        this.slideButtonContainer.add(this.buttonText);

        const ImageContainer = this.slideButtonContainer.getBounds();
        //console.log("Container World X, Y, Width, Height:", ImageContainer.x, ImageContainer.y, ImageContainer.width, ImageContainer.height);

        this.buttonTextIcon  = scene.add.sprite(84, 0, 'pack', 'icon-park_right.png').setScale(0.6);

        this.slideButtonContainer.add(this.buttonTextIcon);

        this.buttonText.postFX.addShine(.5, .3, 3);


        this.buttonTextLoading  = scene.add.sprite(0, 0, 'pack', 'loop-icon.png').setScale(0.6).setVisible(false);

        this.slideButtonContainer.add(this.buttonTextLoading);

        this.buttonTextDone  = scene.add.sprite(0, 0, 'pack', 'v-icon.png').setScale(0.6).setVisible(false);

        this.slideButtonContainer.add(this.buttonTextDone);

        // Add drag event listener
        // scene.input.on('drag', (pointer, gameObject,dragX, dragY) => {

        //     dragX = Phaser.Math.Clamp(dragX, -318/2-32, 318/2+32);
        //     const currentP = 1 - Phaser.Math.Percent(dragX,-318/2-32, 318/2+32);
            
        //     const opacity = Phaser.Math.Clamp(currentP, 0.35, 1);
        //     this.valueText.setAlpha(opacity);


        //     //console.log("currentP",currentP)
        //     gameObject.x = dragX;

        //     const boundsS = this.slideButtonContainer.getBounds();
        //     //console.log("Container World X, Y, Width, Height:", boundsS.x, boundsS.y, boundsS.width, boundsS.height);

        //     this.graphics.clear();
        //     if(gameObject.x == 318/2+32){
                               
        //         this.graphics.fillStyle(0x00FFF0, 1);
    
        //         this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, boundsS.x+boundsS.width/2,102, 10);
        //     }else{
                
        //         this.graphics.fillStyle(0x00A39A, 1);
    
        //         this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, boundsS.x+boundsS.width/2,102, 10);
        //     }
           
           
        // });



        scene.input.on('drag', (pointer, gameObject,dragX, dragY) => {

            //console.log("dragX", dragX)

            dragX = Phaser.Math.Clamp(dragX, -318/2-32, 318/2+32);
            //console.log("dragX CLAMPED", dragX)
            const currentP = 1 - Phaser.Math.Percent(dragX,-318/2-32, +318/2+32);
            //console.log("currentP", currentP )
            const opacity = Phaser.Math.Clamp(currentP, 0.35, 1);
            this.valueText.setAlpha(opacity);


            //console.log("currentP",currentP)
            gameObject.x = dragX;

            const boundsS = this.slideButtonContainer.getBounds();
            //console.log("Container World X, Y, Width, Height:", boundsS.x, boundsS.y, boundsS.width, boundsS.height);

            this.graphics.clear();
            if(gameObject.x == +318/2+32){
                               
                this.graphics.fillStyle(0x00FFF0, 1);
    
                //this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, boundsS.x+boundsS.width/2 -88,102, 10);
                this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, dragX+this.SliderButton.width,102, 10);
                
            }else{
                
                this.graphics.fillStyle(0x00A39A, 1);
    
                //this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, boundsS.x+boundsS.width/2 -88,102, 10);
                //console.log(this.SliderButton,this.SliderBackground,this.SliderButton.width)
                this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, dragX+this.SliderButton.width,102, 10);
            }
           
           
        });

        



        scene.input.on('dragend', async (pointer, gameObject, dragX, dragY, dropped) => this.handleButtonClick(pointer, gameObject, dragX, dragY, dropped, scene));


        


        

        
        //  this.SliderButton.on('drag', (pointer,dragX) => {
        //     //console.log(pointer)
        //     dragX = Phaser.Math.Clamp(dragX, -170, 170);

        //     this.SliderButton.x = dragX
        //     if(this.SliderButton.x == 170){
        //         this.SliderButton.setInteractive(false);
        //     }
        //     // if (!this.isDisabled) {
        //     //     this.setClicked();
        //     // }
        // });

        // this.SliderButton.on('dragend', (pointer, dragX, dragY, dropped) => {
        //     console.log('dragend',dropped)

        //     if(this.SliderButton.x < 170){
        //         this.SliderButton.setInteractive(false);
        //     }
        //     //dragDirection = null;

        // });

        // this.SliderButton.on('pointerup', (pointer) => {
        //     //this.SliderButton.x = -170
        //     console.log('pointeruppointer')
        //     // if (!this.isDisabled) {
        //     //     this.setIdle();
        //     //     if (onClick) onClick(); // Call the provided callback function
        //     // }
        // });


    }


      // Function to handle the button click
    async handleButtonClick(pointer, gameObject, dragX, dragY, dropped, scene) {


        const bounds = this.getBounds();
        if(gameObject.x == 318/2+32){
            //scene.input.setDraggable(gameObject, false);
            const boundsS = this.slideButtonContainer.getBounds();
                                
            // this.graphics.clear();
            // this.graphics.fillStyle(0x00FFF0, 1);

            // this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, boundsS.x+boundsS.width/2-88,102, 10);


            this.buttonTextIcon.setVisible(false)
            this.buttonText.setVisible(false)
            //this.buttonTextLoading.setVisible(true)
            this.buttonTextDone.setVisible(true)

            this.currentCatItem = this.scene.registry.get('cart_items')
            this.currentDraw = this.scene.registry.get('currentDraw');
            
                       
            const myBalance  = this.scene.registry.get('my-balance');

            if (myBalance < this.amount){
                this.scene.scene.pause('BuyTicketScene')
                this.scene.scene.launch('BalanceAlertScene');
                
            }else{


                try {
                    const response = await buyTickets(this.currentCatItem, this.currentDraw.draw_date_id, this.scene.registry.get('gamecode'))
                    
                    if (response.status === 201) {
                      // If HTTP 201, launch Scene A
                      this.scene.registry.set('cart_items', []);  
                      this.scene.registry.set('my-balance', +myBalance -  +this.amount);
                      this.scene.game.events.emit('update-balance', +myBalance -  +this.amount);

                    // const fx = that.preFX.addWipe(0.1, 0, 0);

                    // this.tweens.add({
                    //     targets: fx,
                    //     progress: 1,
                    //     repeatDelay: 1000,
                    //     hold: 1000,
                    //     yoyo: true,
                    //     repeat: -1,
                    //     duration: 2000
                    // });

                      //this.scene.scene.start('MyTicketsScene');
                      this.sceneTransition();
                        // this.scene.scene.transition({
                        //     target: 'MyTicketsScene',
                        //     duration: 2000,
                        //     moveBelow: true,
                        //     //onUpdate: this.transitionOut,
                        //     data: { x: 400, y: 300 }
                        // });
                      
                    } else {

                    //scene.input.setDraggable(gameObject, true);
                      // Check for an error message
                      const errorMessage = response.data.error || 'An unknown error occurred.';
                      
                      console.log("Error Message:", errorMessage)
                      this.resetDragToStart(scene, gameObject, bounds)
                      // Launch Scene B with the error message
                      this.scene.scene.launch('ErrorPopScene', errorMessage);
                      //this.scene.start('SceneB', { errorMessage });
                    }
                } catch (error) {
                    //scene.input.setDraggable(gameObject, true);
                    // Handle any errors (e.g., network issues)
                    const errorMessage = error.message || 'A network error occurred.';
                    console.log("Error Message:", errorMessage)
                    this.resetDragToStart(scene, gameObject, bounds)
                    // Launch Scene B with the error message
                    //this.scene.scene.launch('ErrorPopScene', errorMessage);
                    //this.scene.start('SceneB', { errorMessage });
                }

                // if (res.status == 201){
                //     console.log("message", res.data)
                //     this.scene.registry.set('cart_items', []);
                //     this.handleButtonClick()
                // } else{
                //     console.log("res", res)
                //     let errorMessage = "An Error occured"

                //     if (res.error.data.message !== undefined) {
                //         errorMessage = res.error.data.message
                //     }

                    
                // }
            }
            


        }else {
            this.resetDragToStart(scene, gameObject, bounds)
        }

        // TODO check if i can add an inasctive tween and only activate /deactivate when needed
        

    }

    sceneTransition() {
        // Launch Scene B, but move it off-screen to the right initially

         // Ensure Scene B is started and paused to avoid recreation
        // if (!this.scene.scene.isActive('MyTicketsScene')) {
        //     this.scene.scene.run('MyTicketsScene'); // Start or resume Scene B
        //     this.scene.scene.get('MyTicketsScene').cameras.main.setScroll(this.scene.cameras.main.width, 0);
        // }

        // const fx = this.scene.scene.preFX.addWipe(0.1, 0, 0);

        // this.tweens.add({
        //     targets: fx,
        //     progress: 1,
        //     repeatDelay: 1000,
        //     hold: 1000,
        //     yoyo: true,
        //     repeat: -1,
        //     duration: 2000
        // });
      
        this.scene.scene.launch('MyTicketsScene');
        const sceneB = this.scene.scene.get('MyTicketsScene');

        sceneB.events.once('create', () => {
                //this.scene.scene.stop('BuyTicketScene');

                if (sceneB) {
                    // Check if SceneB is active
                    if (this.scene.scene.isActive('MyTicketsScene')) {
                    //console.log('SceneB is active.');
                    } else if (this.scene.scene.isPaused('MyTicketsScene')) {
                    //console.log('SceneB is paused.');
                    } else if (this.scene.scene.isSleeping('MyTicketsScene')) {
                    //console.log('SceneB is sleeping.');
                    } else {
                    //console.log('SceneB is stopped or not active.');
                    }
                } else {
                    //console.log('SceneB does not exist or is not registered.');
                
                }
                

                //console.log("sceneB", sceneB)
                //console.log("sceneB", sceneB.cameras.main)
                sceneB.cameras.main.scrollX = this.scene.cameras.main.width;
            
                // Slide Scene A to the left
                this.scene.tweens.add({
                    targets: this.scene.cameras.main,
                    scrollX: this.scene.cameras.main.width,
                    duration: 500,
                });
            
                // Slide Scene B into view
                this.scene.tweens.add({
                targets: sceneB.cameras.main,
                scrollX: 0,
                duration: 500,
                onComplete: () => {
                    this.scene.scene.stop('BuyTicketScene'); // Stop Scene A
                }
                });

            })




      }

    // sceneTransition() {
    //     // Switch to Scene B but keep it hidden initially
    //     this.scene.scene.launch('MyTicketsScene');
    //     const sceneB = this.scene.scene.get('MyTicketsScene');
    //     sceneB.cameras.main.setAlpha(0); // Keep Scene B hidden
    
    //     // Create a circular mask that will expand to reveal Scene B
    //     const maskShape = this.scene.add.circle(0, 0, 10, 0xffffff).setOrigin(0.5, 0.5);
    //     maskShape.setPosition(this.scene.cameras.main.width / 2, this.scene.cameras.main.height / 2);
    
    //     const mask = maskShape.createBitmapMask();
    //     sceneB.cameras.main.setMask(mask);
    
    //     // Animate the circle mask to expand
    //     this.scene.tweens.add({
    //       targets: maskShape,
    //       radius: 800, // Adjust to fully cover the screen
    //       duration: 1500,
    //       onComplete: () => {
    //         sceneB.cameras.main.clearMask(); // Clear the mask after the transition
    //         this.scene.scene.stop('BuyTicketScene'); // Stop Scene A
    //       }
    //     });
    //   }
        
    
    resetDragToStart(scene, gameObject, bounds){
      

        this.buttonTextIcon.setVisible(true)
        this.buttonText.setVisible(true)
        //this.buttonTextLoading.setVisible(true)
        this.buttonTextDone.setVisible(false)
        //console.log("resetDragToStart::", scene, gameObject)
        //if(gameObject.x < 318/2+32){
            scene.tweens.add({
                targets: gameObject,
                x: -318/2-32,  // Move the sprite by -100 on x-axis
                duration: 500,      // Duration of the tween in milliseconds
                ease: 'Power2',      // Ease-in effect
                onComplete: () => {
                    this.valueText.setAlpha(1);
                },
                onUpdate: () =>{
                    
                    const boundsS = this.slideButtonContainer.getBounds();

                    const currentP = 1 - Phaser.Math.Percent(boundsS.x,76, 318/2+32);
                    //console.log("currentP",currentP)
                    //if(gameObject.x > 20){
                        const opacity = Phaser.Math.Clamp(currentP, 0.35, 1);
                        this.valueText.setAlpha(opacity);
                    //}

                    this.graphics.clear();
                    this.graphics.fillStyle(0x00A39A, 1);
        
                    this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2+2, this.SliderButton.x+this.SliderButton.width-16,102, 10);
                }
            });
        //}
    }

    // update() {
    //     this.graphics.clear();
    //     this.graphics.fillStyle(0x00A39A, 1);
    //     this.graphics.fillRoundedRect(-bounds.width/2, -bounds.height/2, this.SliderButton.width,100, 10);
    // }

       // Set the Slider to disabled state
    setDisabled() {
        
        this.isDisabled = true;
        this.SliderButton.setTexture('pack', 'Button - Primary - Disabled.png');
        this.slideButtonContainer.disableInteractive();
        this.buttonText.setColor("#757B8C")
        this.buttonTextIcon.setAlpha(0.2)
        this.buttonText.clearFX()
    }

    setValue(value){
        if(value == 0 ){
            this.amount = parseFloat(value).toFixed(2);
            this.valueText.setText(`${this.currency}${this.amount}`);
            this.setDisabled()
        }

        if(value >0 ){
          
            this.amount = parseFloat(value).toFixed(2);
            //console.log(" this.amount",  this.amount)
            //console.log("this.valueText" , this.valueText, )
            this.valueText.setText(`${this.currency}${this.amount}`);
            //console.log("ENABLED", value)
            this.enable()
            //console.log("this.enable()")
        }       
    }

    enable() {
        this.isDisabled = true;
        this.slideButtonContainer.setInteractive();
        this.SliderButton.setTexture('pack', 'Button - Primary - Default.png');
        this.buttonText.setColor("#FFFFFF")
        this.buttonTextIcon.setAlpha(1)
    }
}



